import React, { useCallback, useMemo, useState } from 'react';
import { Button, Spin, message, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from '@apollo/client';
import {
  UPDATE_PARTNER,
  QUERY_LIST_REFERRERS,
} from '~pages/dashboard/referral/partner-account/queries';

function AccountOwnerEditor({ partnerId, currentOwnerId, onClose }) {
  const { t } = useTranslation();
  const [owner, setOwner] = useState(currentOwnerId);
  const { loading: referrerListLoading, data: referrerListResponse } = useQuery(
    QUERY_LIST_REFERRERS,
    {
      variables: {
        pageNumber: 1,
        pageSize: 100,
      },
    },
  );

  const referrerList = useMemo(() => {
    return (
      referrerListResponse?.referrers?.edges.map(edge => ({
        label: `${edge?.node?.firstName || ''} ${edge?.node?.lastName || ''}`,
        value: edge.node.id,
      })) || []
    );
  }, [referrerListResponse]);

  const [updatePartner, { loading: updatePartnerLoading }] = useMutation(UPDATE_PARTNER, {
    onError: e => {
      message.error(e.message);
    },
  });

  const handleSubmit = useCallback(async (referrerId, enabled, payoutPlanId) => {
    const response = await updatePartner({
      variables: {
        input: { id: partnerId, referrerId: referrerId, enabled, payoutPlanId },
      },
    });

    if (response?.data?.updatePartner) {
      message.success('Update Partner Account Owner Success');
      onClose();
    }
  }, []);

  return (
    <>
      <div className="partner-register-city-editor__body" style={{ marginTop: '8px' }}>
        <section className="partner-register-city-editor__section">
          {referrerListLoading && !referrerList.length ? (
            <div className="partner-register-city-editor__spin">
              <Spin />
            </div>
          ) : (
            <main className="partner-register-city-editor__main">
              <div className="">
                <h3 className="partner-account-selector-title">
                  {t('cms.referral.partner_account.account_owner')}
                </h3>
                <Select
                  className="partner-register-city-editor__selector"
                  onChange={value => {
                    setOwner(value);
                  }}
                  value={owner}
                  placeholder={'Please Select City'}
                >
                  {referrerList.map(city => (
                    <Select.Option value={city.value}>{city.label}</Select.Option>
                  ))}
                </Select>
              </div>
            </main>
          )}
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>
        <Button
          type="primary"
          size="large"
          className="partner-register-city-editor__save-button"
          loading={updatePartnerLoading}
          onClick={() => handleSubmit(owner, true)}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </>
  );
}

export default AccountOwnerEditor;
